import { BaseService } from "mrb/core";
import { LoadioAlbumTrackFileStreamApiRouteService } from "common/services";

class LoadioAlbumTrackFileStreamService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioAlbumTrackFileStreamApiRouteService());
    }

    get(id, params, abortSignal = null) {
        const url = this.routeService.get(id, params);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default LoadioAlbumTrackFileStreamService;
